class ThemeService {

    private renderer!: CanvasRenderingContext2D; 

    public applyTheme(variables: Variables) {
        this.setupRenderer();
        
        const root = document.querySelector(':root') as HTMLElement;
    
        root.style.setProperty("--primary-button-gradient-1", this.changeColor(variables.buttonPrimary, 110));
        root.style.setProperty("--primary-button-gradient-2", this.changeColor(variables.buttonPrimary, 110));
        root.style.setProperty("--primary-button-border", this.changeColor(variables.buttonPrimary, 105));
        root.style.setProperty("--primary-button-shadow", this.transparentize(variables.buttonPrimary, 0.25))

        root.style.setProperty("--primary-button-hover-gradient-1", this.changeColor(variables.buttonPrimary, 95));
        root.style.setProperty("--primary-button-hover-gradient-2", this.changeColor(variables.buttonPrimary, 95));
        root.style.setProperty("--primary-button-hover-border", this.changeColor(variables.buttonPrimary, 85));

        root.style.setProperty("--primary-button-pulse", this.transparentize(variables.buttonPrimary, 0.50));

        root.style.setProperty("--main-color", variables.menu);
        root.style.setProperty("--main-color-hover", this.changeColor(variables.menu, 120, 50));
        root.style.setProperty("--main-color-darker", this.changeColor(variables.menu, 80));

        root.style.setProperty("--bs-link-color", this.changeColor(variables.buttonPrimary, 90));
        root.style.setProperty("--bs-link-hover-color", this.changeColor(variables.buttonPrimary, 70));
        
    }

    private setupRenderer() {
        const canvas = document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        this.renderer = canvas.getContext("2d", { willReadFrequently: true })!;
    }

    private changeColor(color: string, brightness: number, saturation: number = 100): string {
    
        this.renderer.fillStyle = color;
        this.renderer.filter = `brightness(${brightness}%) saturate(${saturation}%)`;
        this.renderer.fillRect(0, 0, 1, 1);

        const data = this.renderer.getImageData(0, 0, 1, 1).data;

        return `rgba(${data[0]}, ${data[1]}, ${data[2]})`;
    }

    private transparentize(color: string, alpha: number) {

        this.renderer.fillStyle = color;
        this.renderer.fillRect(0, 0, 1, 1);

        const data = this.renderer.getImageData(0, 0, 1, 1).data;

        return `rgba(${data[0]}, ${data[1]}, ${data[2]}, ${alpha})`;
    }
}

const singleton = new ThemeService();
export default singleton; 

interface Variables {
    buttonPrimary: string;
    menu: string;
}